import { render, staticRenderFns } from "./DevelopPhone.vue?vue&type=template&id=2f98e970&"
import script from "./DevelopPhone.vue?vue&type=script&lang=js&"
export * from "./DevelopPhone.vue?vue&type=script&lang=js&"
import style0 from "./DevelopPhone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports